import { useState, useEffect } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import TabPanel from './TabPanel';
import { setReRender, setTabOnFocus } from '../../store/global/actions';
import { marginBottomForBreadCrumb } from '../../config/styles';
import { useDispatch, useSelector } from 'react-redux';
import BreadCrumb from '../atoms/breadcrumb/';
import { getTabOnFocus } from '../../store/global/selectors';
import Divider from '@material-ui/core/Divider';
import { Grid } from '@material-ui/core';
import { handleSnackBar } from '../../store/global/actions';
import { toggleRightDrawer } from '../../store/global/actions';
import { getElementOnFocus } from '../../store/global/selectors';
import MappingSelector from '../molecules/dashboardBuilder/MappingSelector';
import { getViews } from "../../store/views/selectors";
import { findSelectedSchema } from "../../services/builder/util";
import EventSelector from '../molecules/dashboardBuilder/EventSelector';
import FieldForm from '../molecules/dashboardBuilder/FieldForm';


export default function ViewField({ element }) {
    const dispatch = useDispatch();
    const tabOnFocus = useSelector(getTabOnFocus);
    const elementOnFocus = useSelector(getElementOnFocus);
    const selectedView = useSelector(getViews)


    const [openTab, setOpenTab] = useState(0);

    const schemas = selectedView?.view_schema || [];
    const selectedField = findSelectedSchema({ schemas, id: element.id });
    console.log("Selected child------------", {selectedField})

    const hideDatasourceTab = selectedField?.viewCopy != undefined && selectedField?.viewCopy === true ? true : false;
    const hideDeleteButton =  selectedField?.viewCopy != undefined && selectedField?.viewCopy === true ? true : false;

    const detailsBC = [
        { label: 'View Field', url: null },
        { label: elementOnFocus?.name ? elementOnFocus.name : "", url: null }
    ];


    useEffect(() => {
        setOpenTab(tabOnFocus);
    }, [tabOnFocus])

    const onCompletion = (type, action) => {
        if (action != undefined) {
            switch (action) {
                case 'add':
                    dispatch(handleSnackBar({ open: true, message: `${type} created`, severity: "success" }));
                    break;

                case 'edit':
                    dispatch(handleSnackBar({ open: true, message: `${type} updated`, severity: "success" }));
                    dispatch(toggleRightDrawer());
                    break;

                case 'delete':
                    dispatch(handleSnackBar({ open: true, message: `${type} deleted`, severity: "success" }));
                    dispatch(toggleRightDrawer());
                    break;

            }
            dispatch(setReRender());
        }
    }

    const onClose = () => {
        dispatch(toggleRightDrawer());
    }

    return (
        <>
            <AppBar position="static">
                <Tabs value={openTab} onChange={(e, v) => { dispatch(setTabOnFocus(v)); setOpenTab(v) }} aria-label="simple tabs example">
                    <Tab label="Field" />
                    { !hideDatasourceTab &&  <Tab label="Data Source" disabled={elementOnFocus.action === "create" ? true : false} /> }
                    { selectedField?.type == 'table-button' && < Tab label="Operation" disabled={elementOnFocus.action === "create" ? true : false} />}
                </Tabs>
            </AppBar>


            <TabPanel value={openTab} index={0} >
                <Grid container direction={"row"} spacing={2}>
                    <Grid item xs={8}>
                        <BreadCrumb items={detailsBC} />
                    </Grid>
                </Grid>
                <Divider style={marginBottomForBreadCrumb} />
                <FieldForm action={element.action} parent={element.parentId} selectedField={selectedField}/>
            </TabPanel>

            { !hideDatasourceTab && 
            <TabPanel value={openTab} index={1} >
                <Grid container direction={"row"} spacing={2}>

                    <Grid item xs={8}>
                        <BreadCrumb items={[...detailsBC, { label: 'Data Source', url: null }]} />
                    </Grid>

                </Grid>

                <Divider style={marginBottomForBreadCrumb} />

                < MappingSelector parentID={elementOnFocus.parentID} id={elementOnFocus.id} type={elementOnFocus.type} action={elementOnFocus.action} onClose={onClose} rootId={elementOnFocus.rootId} onCompletion={onCompletion} />

            </TabPanel> }

            <TabPanel value={openTab} index={2} >
                <Grid container direction={"row"} spacing={2}>

                    <Grid item xs={8}>
                        <BreadCrumb items={[...detailsBC, { label: 'Operation', url: null }]} />
                    </Grid>


                </Grid>

                <Divider style={marginBottomForBreadCrumb} />

                <EventSelector id={element.id} action={elementOnFocus.action} onCompletion={onCompletion} onClose={onClose} parentID={elementOnFocus.parentID} rootId={elementOnFocus.rootId} />


            </TabPanel>


        </>
    )
}